import React, { useEffect, useState } from 'react';
import { Button, CircularProgress, Container, Snackbar, Typography } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import * as ROUTES from "../../../constants/routes";
import { compose } from 'recompose';
import { withAuthorization } from '../../Session';
import { withRouter } from 'react-router-dom';
import { FirebaseContext, withFirebase } from '../../Firebase';
import Navigation from '../../Navigation';
import CustomDataTable from '../../CustomDataTable';
import moment from 'moment';
import axios from 'axios';
import { Alert } from '@material-ui/lab';
import Helpers from '../../Helpers';

const helpers = new Helpers();

const ArchiveButton = ({ email, token, getUserList }) => {
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");

    const handleArchive = async (e) => {
        try {
            e.stopPropagation();

            const confirm = window.confirm(`Are you sure you want to activate this user ${email}?`);
            if (!confirm) return;

            setLoading(true);

            const res = await axios.post(
                ROUTES.FUNCTIONAL_BASE_URL + "clients-archive-archive/set-user",
                JSON.stringify({
                    email,
                    isArchive: false,
                }),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const message = res?.data?.message || "Activated successfully!";
            setResponseMessage(message);
            setOpenSnackbar(true);

            if (getUserList) await getUserList();
        } catch (error) {
            console.error("Archive failed:", error);
            alert("Failed to archive");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                variant="outlined"
                onClick={handleArchive}
                disabled={loading}
                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                style={{ backgroundColor: "#256141", color: "white", borderColor: "#256141" }}
            >
                {loading ? "Activating" : "Set Active"}
            </Button>

            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert onClose={() => setOpenSnackbar(false)} severity="success" variant="filled">
                    {responseMessage}
                </Alert>
            </Snackbar>
        </>
    );
};

const ArchivedClients = (props) => {
    const { firebase } = props;
    const db = firebase.db;

    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchClients = async () => {
        try {
            const snapshot = await db
                .collection('users')
                .where('role', '==', 'client')
                .where('archived', '==', true)
                .get();

            const fetchedClients = snapshot.docs
                .map((doc) => {
                    const data = doc.data();
                    return {
                        id: doc.id,
                        name: `${data.firstName} ${data.lastName}`,
                        email: data.email || '',
                        dateCreated: data.dateCreated?.toDate() ?? null,
                    };
                })
                .sort((a, b) => b.dateCreated - a.dateCreated);
            setClients(fetchedClients);
        } catch (error) {
            console.error('Error fetching archived clients:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchClients();
    }, []);

    const columns = [
        {
            name: 'dateCreated',
            label: 'Registration Date',
            options: {
                sort: true,
                customBodyRender: (value) => {
                    if (!value) return 'N/A';
                    return moment(value).format('MM/DD/YYYY HH:mm');
                },
            },
        },
        { name: 'name', label: 'Name' },
        { name: 'email', label: 'Email' },
        {
            name: "actions",
            label: "Actions",
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    const rowData = tableMeta.rowData;
                    const email = rowData[2];
                    const token = helpers.getCookie("token");
                    return (
                        <ArchiveButton email={email} token={token} getUserList={() => fetchClients()} />
                    );
                }
            }
        }
    ];

    const options = {
        selectableRows: 'none',
        download: false,
        print: false,
        responsive: 'standard',
    };

    return (
        <div className="userListRoot">
            <div className="userListpaper">
                <Typography variant="h5" gutterBottom>
                    Archived Clients
                </Typography>

                {loading ? (
                    <CircularProgress />
                ) : (
                    <CustomDataTable
                        title={'Archived Clients List'}
                        data={clients}
                        columns={columns}
                        options={options}
                    />
                )}
            </div>
        </div>
    );
}

const condition = (authUser) => !!authUser;

const ArchivePage = compose(
    withAuthorization(condition),
    withRouter,
    withFirebase
)(() =>
    <FirebaseContext.Consumer>
        {(firebase) => (
            <Navigation
                content={
                    <ArchivedClients
                        firebase={firebase}
                    />
                }
            />
        )}

    </FirebaseContext.Consumer>
)

export default ArchivePage;